<template>
  <hr class="horizontal-line component"/>
</template>

<script>
    export default {
        name: 'HorizontalLine'
    }
</script>

<style scoped>
  /*copied from publicera*/
  hr {
    box-sizing: content-box;
    overflow: visible;
  }

  .horizontal-line {
    height: 1px;
    border: none;
    background-color: #f1f1f1;
    margin-left: auto;
    margin-right: auto;
    max-width: calc(1200px - 2rem);
  }
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/HorizontalLineComponent.vue